import { filter, type Observable } from 'rxjs';
import { Store } from 'store';
import type { DeepNonNullable } from 'contracts';
import is from 'utils/is';

type ContainerSize = 'default' | 'fullWidth';

interface LayoutContainerStore {
  size: ContainerSize | undefined;
}

class LayoutContainer extends Store<LayoutContainerStore> {
  private history: Array<[owner: symbol, size: ContainerSize]> = [];

  constructor() {
    super({ name: 'layout-container', initialState: { size: undefined } });
  }

  public get onChange$(): Observable<DeepNonNullable<LayoutContainerStore>> {
    return super.onChange$.pipe(filter((s): s is DeepNonNullable<LayoutContainerStore> => !is.nullish(s.size)));
  }

  setSize(size: ContainerSize, owner: symbol): () => void {
    this.history.unshift([owner, size]);

    this.set('size', size);

    return () => {
      this.history = this.history.filter(([o]) => o !== owner);

      this.set('size', this.history[0]?.[1] || 'default');
    };
  }
}

export type { LayoutContainerStore, ContainerSize };
export default new LayoutContainer();
